export default "__VITE_ASSET__DIfG$uV2__"